module.exports = __webpack_public_path__ + "img/c_bg.00d85d68.png";